<template>
  <div class="common__main-contener pb-4">
    <h5 class="font-weight-bold mb-3">Information</h5>
    <div class="scroll-area">
      <div v-if="informations.length > 0">
        <div
          class="information__description"
          v-for="information of informations"
          :key="information.notificationId"
        >
          <div class="mr-2">{{information.sendDate | ymd}}</div>
          <router-link
            :to="{
              name: 'Information',
              params: {id: information.notificationId},
            }"
            class="information__description-Lesson"
          >
            {{information.subject}}
          </router-link>
        </div>
      </div>
      <div v-else>
        <h6>No information</h6>
      </div>
    </div>
    <div
      class="mt-4 d-flex justify-content-end"
      v-if="this.$store.state.auth.profile.authority === 'admin'"
    >
      <b-button pill variant="primary" :to="{ name:'Mails' }" class="mr-2">
        more
      </b-button>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  created() {
    if (this.$store.state.auth.profile.authority !== 'admin') {
      this.$store.dispatch('fetchInformations', this.$store.state.auth.profile.id)
      return
    }
    this.$store.dispatch('fetchInformations')
  },

  computed: {
    informations() {
      return this.$store.state.mypage.informations;
    },
  },

  filters: {
    ymd(date) {
      return moment(date, 'YYYYMMDD').format('YYYY/MM/DD')
    },
  },
}
</script>

<style scoped>
.information__description {
  display: flex;
  padding-left:20px;
}

.information__description-Lesson {
  margin-right:10px;
}

.information__description:not(:last-child) {
  margin-bottom: 10px;
}

.scroll-area {
  height:200px;
  overflow-y: scroll;
}

/*スクロールバー全体*/
::-webkit-scrollbar {
    width: 15px;
}

/*スクロールバーの軌道*/
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 3px rgba(0, 0, 0, .1);
  border: 1px solid #B0C4DE;
}

/*スクロールバーの動く部分*/
::-webkit-scrollbar-thumb {
  background-color: #B0C4DE;
}
</style>
